import React from "react";
import { colors, imgColors } from "../../carbonNeutrality";
import "./index.scss";
import { disposeColors } from "pages/CarbonNeutralityDisclosure/config";

/**
 * type === 1 碳中和 type === 2
 * @param {*} props
 * @returns
 */
export default function EmissionDetails(props) {
  const { data = [], type } = props;
  const newColors = disposeColors(type)?.colorList;
  return (
    <div className="emission-details-wrapper">
      {data?.map((item, idx) => {
        const dateIndex = idx % newColors.length;
        return (
          <div className="emission-details-item">
            <div className="title" style={{ color: newColors[dateIndex] }}>
              {item?.allName}
            </div>
            {item?.children?.map((subItem) => {
              const ratio = subItem?.ratio >= 100 ? 100 : subItem?.ratio;
              return (
                <div className="mission-details-item-title-content">
                  <div className="mission-details-item-title">
                    <div className="item-title">{subItem?.allName}</div>
                    <div className="values">{subItem?.carbon}</div>
                  </div>
                  <div className="mission-details-item-content">
                    <div
                      className="classification-data-item"
                      style={{
                        width: `${ratio}%`,
                        backgroundColor: newColors[dateIndex],
                      }}
                    ></div>
                    <div
                      className="classification-data-text"
                      style={{
                        left: `${ratio > 95 ? 88 : ratio}%`,
                      }}
                    >
                      {subItem?.ratio >= 100 ? 100 : subItem?.ratio}%
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
